import { render, staticRenderFns } from "./PageVenueList.vue?vue&type=template&id=0dc884fa&scoped=true"
import script from "./PageVenueList.vue?vue&type=script&lang=js"
export * from "./PageVenueList.vue?vue&type=script&lang=js"
import style0 from "./PageVenueList.vue?vue&type=style&index=0&id=0dc884fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc884fa",
  null
  
)

export default component.exports